var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bcx-user-list-item"},[_c('BCXAvatar',{attrs:{"user-id":_vm.userId,"show-online-indicator":false,"size":_vm.avatarSize}}),_c('div',{staticClass:"bcx-user-list-item__content"},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.displayName)+" ")]},{"displayName":_vm.displayName})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }